module.exports = __webpack_public_path__ + "img/img_half_futanoura_3.c99fcaba.png";